module.exports = __webpack_public_path__ + "img/close-dishe-arrow.dc21a7fb.svg";